var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"version-tag"},[_vm._v(" "+_vm._s(_vm.$t('about.poweredBy'))+" - "+_vm._s(_vm.$t('about.version'))+" "+_vm._s(_vm.versionNumber)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }